import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CarRequestType, CarType, MoneyRequestType } from "types/loadedData";

interface RequestState {
  moneyRequests: MoneyRequestType[];
  moneyRequest: MoneyRequestType | null;
  carRequests: CarRequestType[];
  carRequest: CarRequestType | null;
}

const initialState: RequestState = {
  moneyRequests: [],
  moneyRequest: null,
  carRequests: [],
  carRequest: null,
};

export const car = createSlice({
  name: "car",
  initialState,
  reducers: {
    setMoneyRequests: (state, action: PayloadAction<MoneyRequestType[]>) => {
      state.moneyRequests = action.payload;
    },
    setMoneyRequest: (
      state,
      action: PayloadAction<MoneyRequestType | null>
    ) => {
      state.moneyRequest = action.payload;
    },
    setCarRequests: (state, action: PayloadAction<CarRequestType[]>) => {
      state.carRequests = action.payload;
    },
    setCarRequest: (state, action: PayloadAction<CarRequestType | null>) => {
      state.carRequest = action.payload;
    },
  },
});

export const {
  setCarRequest,
  setCarRequests,
  setMoneyRequest,
  setMoneyRequests,
} = car.actions;

export default car.reducer;
